import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';

export const publicOverquota = isFeature('ab-public-overquota');

interface OverquotaFeatureConfig {
    enable: boolean;
    variant: 'b' | 'c' | 'd';
}

export const overquotaUserLockInPublic: OverquotaFeatureConfig = getFeature('overquota-user-lock-in-public') || {
    enable: false,
    variant: 'b',
};
